import React, { useRef } from "react";
import {
  Image,
  Keyboard,
  Platform,
  Pressable,
  Text,
  TextInput,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import { ids, styles } from "./Style";

import { INFO_ICON } from "../../resources/IMAGES";
import { messages } from "../../resources/strings";
import { theme } from "../../theme/theme";

const PasswordForm = ({
  password,
  confirmPassword,
  passwordHelpText,
  confirmPasswordHelpText,
  showPassword,
  showConfirmPassword,
  isFinalSubmit,
  validatePassword,
  showPasswordLabel,
  showConfirmPasswordLabel,
  matchPasswords,
  setConfirmPassword,
  togglePasswordVisiblity,
  toggleConfirmPasswordVisiblity,
  registerNewUser,
}: {
  password: string;
  confirmPassword: string;
  passwordHelpText: string;
  confirmPasswordHelpText: string;
  showPassword: boolean;
  showConfirmPassword: boolean;
  isFinalSubmit: boolean;
  showPasswordLabel: string;
  showConfirmPasswordLabel: string;
  validatePassword: (value: string, isFinalSubmit: boolean) => void;
  matchPasswords: (password: string, confirmPassword: string) => void;
  setConfirmPassword: (value: string) => void;
  togglePasswordVisiblity: (value: boolean) => void;
  toggleConfirmPasswordVisiblity: (value: boolean) => void;
  registerNewUser: () => void;
}) => {
  const confirmPasswordRef = useRef<TextInput>(null);
  const getInputStyle = (key?: any, value?: any) =>
    key && value
      ? key == value
        ? styles.passwordInput
        : { ...styles.inputRed, paddingRight: 60 }
      : styles.passwordInput;

  return (
    <>
      <View style={[styles.formGroup]} dataSet={{ media: ids.formGroup }}>
        <Text style={[styles.inputLabel]} dataSet={{ media: ids.inputLabel }}>
          Password
        </Text>
        <View style={styles.passwordContainer}>
          <TextInput
            style={
              passwordHelpText == "" ||
              (passwordHelpText == messages.validation.invalidPasscodeFormat &&
                !isFinalSubmit)
                ? styles.passwordInput
                : styles.inputRed
            }
            onChangeText={(text) => validatePassword(text, isFinalSubmit)}
            value={password}
            autoCorrect={false}
            secureTextEntry={!showPassword}
            autoCapitalize="none"
            returnKeyType="next"
            maxLength={20}
            // contextMenuHidden={true} copiability
            onSubmitEditing={() => {
              // @ts-ignore
              confirmPasswordRef.current.focus();
            }}
            blurOnSubmit={false}
          />
          <Pressable
            style={[styles.showPassowrd]}
            dataSet={{ media: ids.showPassowrd }}
            onPress={() => {
              togglePasswordVisiblity(!showPassword);
            }}
          >
            <Text style={[styles.whiteText]} dataSet={{ media: ids.whiteText }}>
              {showPasswordLabel}
            </Text>
          </Pressable>
        </View>
        <View
          style={[styles.passwordErrorContainer]}
          dataSet={{ media: ids.passwordErrorContainer }}
        >
          {!isFinalSubmit ? (
            <Text
              style={[styles.passwordMessage, styles.passwordMessageError]}
              dataSet={{ media: ids.passwordMessage }}
            >
              {passwordHelpText}
            </Text>
          ) : (
            <Text
              style={[styles.passwordMessage]}
              dataSet={{ media: ids.passwordMessage }}
            >
              {passwordHelpText}
            </Text>
          )}
        </View>
      </View>
      <View style={[styles.formGroup]} dataSet={{ media: ids.formGroup }}>
        <Text style={[styles.inputLabel]} dataSet={{ media: ids.inputLabel }}>
          Confirm Password
        </Text>
        <View style={styles.passwordContainer}>
          <TextInput
            ref={confirmPasswordRef}
            style={getInputStyle(confirmPasswordHelpText)}
            onChangeText={(text) =>
              isFinalSubmit
                ? matchPasswords(password, text)
                : setConfirmPassword(text)
            }
            value={confirmPassword}
            autoCorrect={false}
            secureTextEntry={!showConfirmPassword}
            autoCapitalize="none"
            returnKeyType="done"
            maxLength={20}
            onSubmitEditing={() => {
              registerNewUser();
            }}
            blurOnSubmit={false}
          />
          <Pressable
            style={[styles.showPassowrd]}
            dataSet={{ media: ids.showPassowrd }}
            onPress={() => {
              toggleConfirmPasswordVisiblity(!showConfirmPassword);
            }}
          >
            <Text style={[styles.whiteText]} dataSet={{ media: ids.whiteText }}>
              {showConfirmPasswordLabel}
            </Text>
          </Pressable>
        </View>
        <View
          style={[styles.errorContainer]}
          dataSet={{ media: ids.errorContainer }}
        >
          <Text
            style={[styles.errorMessage]}
            dataSet={{ media: ids.errorMessage }}
          >
            {confirmPasswordHelpText}
          </Text>
        </View>
      </View>
      <View
        style={[styles.errorContainer]}
        dataSet={{ media: ids.errorContainer }}
      >
        <Image
          style={styles.infoIcon}
          dataSet={{ media: ids.infoIcon }}
          source={INFO_ICON}
        />
        <Text style={[styles.infoMessage]} dataSet={{ media: ids.infoMessage }}>
          {messages.validation.codeFormat}
        </Text>
      </View>

      <Pressable
        style={[styles.makeaPaymentBtn]}
        dataSet={{ media: ids.makeaPaymentBtn }}
        onPress={() => {
          registerNewUser();
        }}
      >
        <Text style={[styles.btnText]} dataSet={{ media: ids.btnText }}>
          Finish
        </Text>
      </Pressable>
    </>
  );
};

export default PasswordForm;
